import React, { useEffect, useRef, useState } from "react";
import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeaderForTeenPatti";
import TpStudioHeader from "../../client/tp-studio/tp-studio-header";
import TPStudioSidebar from "../../client/tp-studio/TPStudioSidebar";
import reconnecting from "../../../assets/topstudio/images/rolet/reconnecting.gif";
import TpStudioLoader from "../../client/tp-studio/tp-studio-loader";
import "../../../assets/topstudio/styles/Player.css";
import useSocket from "../../../hooks/useSocket";
import useClosedPhaseOverlay from "../../../hooks/useClosedPhaseOverlay";
import TeenPattisCasinoBetslipWeb from "./teenpatti_casino_betslip_web";
import axiosInstance from "../../../utils/axiosInstance";
import Volume from "./Volume";
import { isMobile } from "react-device-detect";
import TPPopUpBetSlip from "./teenpatti_casino_betslip_popup.jsx";
import Lucky7SecondResult from "../../client/tp-studio/tp-result/Lucky7SecondResult.jsx";
import LuckySecRules from "./pop-up/lucky7sec-rules.jsx";

import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../store/userSlice";

export default function Lucky7SecoundVirtual() {
  const dispatch = useDispatch();
  const [stakeLimit, setStakeLimit] = useState(0);
  const [showRules, setShowRules] = useState(false);
  const [showBetSlipPopup, setShowBetSlipPopup] = useState(false);
  const [betButtonShow, setBetButtonShow] = useState(true);
  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);
  const [resultList, setResultList] = useState([]);
  const [activeTabIndex, setActiveTabIndex] = useState(1);
  const [displayLoader, setDisplayLoader] = useState(true);

  const [showBetSlip, setShowBetSlip] = useState(false);
  const [placeBetObject, setPlaceBetObject] = useState({});
  const [betErrorMessageObj, setBetErrorMessage] = useState({});
  const [open, setOpen] = useState(false);

  const [LowCard, setLowCard] = useState(0);
  const [highCard, setHighCard] = useState(0);
  const [oddCard, setOddCard] = useState(0);
  const [evenCard, setEvenCard] = useState(0);
  const [redCard, setRedCard] = useState(0);
  const [blackCard, setBlackCard] = useState(0);
  const [suitCard, setSuitCard] = useState(0);
  const [threeCard, setThreeCard] = useState(0);
  const [singleCard, setSingleCard] = useState(0);
  const [suspend1, setSuspend1] = useState(1);
  const [roundId, setRoundId] = useState("");
  const [lastStatus, setLastStatus] = useState(null);

  const [lowCardBook, setLowCardBook] = useState({ back: 0, lay: 0 });
  const [highCardBook, setHighCardBook] = useState({ back: 0, lay: 0 });
  const [oddCardBook, setOddCardBook] = useState({ back: 0, lay: 0 });
  const [evenCardBook, setEvenCardBook] = useState({ back: 0, lay: 0 });
  const [redCardBook, setRedCardBook] = useState({ back: 0, lay: 0 });
  const [blackCardBook, setBlackCardBook] = useState({ back: 0, lay: 0 });
  const [clubCardBook, setClubCardBook] = useState({ back: 0, lay: 0 });
  const [diamondCardBook, setDiamondCardBook] = useState({ back: 0, lay: 0 });
  const [heartCardBook, setHeartCardBook] = useState({ back: 0, lay: 0 });
  const [spadeCardBook, setSpadeCardBook] = useState({ back: 0, lay: 0 });
  const [A23CardBook, setA23CardBook] = useState({ back: 0, lay: 0 });
  const [four56CardBook, setFour56CardBook] = useState({ back: 0, lay: 0 });
  const [eight910CardBook, setEight910CardBook] = useState({ back: 0, lay: 0 });
  const [jQKCardBook, setJQKCardBook] = useState({ back: 0, lay: 0 });

  const [oneCardBook, setOneCardBook] = useState({ back: 0, lay: 0 });
  const [twoCardBook, setTwoCardBook] = useState({ back: 0, lay: 0 });
  const [threeCardBook, setThreeCardBook] = useState({ back: 0, lay: 0 });
  const [fourCardBook, setFourCardBook] = useState({ back: 0, lay: 0 });
  const [fiveCardBook, setFiveCardBook] = useState({ back: 0, lay: 0 });
  const [sixCardBook, setSixCardBook] = useState({ back: 0, lay: 0 });
  const [sevenCardBook, setSevenCardBook] = useState({ back: 0, lay: 0 });
  const [eightCardBook, setEightCardBook] = useState({ back: 0, lay: 0 });
  const [nineCardBook, setNineCardBook] = useState({ back: 0, lay: 0 });
  const [tenCardBook, setTenCardBook] = useState({ back: 0, lay: 0 });
  const [elevenCardBook, setElevenCardBook] = useState({ back: 0, lay: 0 });
  const [twelveCardBook, setTwelveCardBook] = useState({ back: 0, lay: 0 });
  const [thirteenCardBook, setThirteenCardBook] = useState({ back: 0, lay: 0 });

  //winner
  const [lowCardWinner, setLowCardWinner] = useState(false);
  const [highCardWinner, setHighCardWinner] = useState(false);
  const [oddCardWinner, setOddCardWinner] = useState(false);
  const [evenCardWinner, setEvenCardWinner] = useState(false);
  const [redCardWinner, setRedCardWinner] = useState(false);
  const [blackCardWinner, setBlackCardWinner] = useState(false);

  const [clubCardWinner, setClubCardWinner] = useState(false);
  const [heartCardWinner, setHeartCardWinner] = useState(false);
  const [spadeCardWinner, setSpadeCardWinner] = useState(false);
  const [diamondCardWinner, setDiamondCardWinner] = useState(false);

  const [A23CardWinner, setA23CardWinner] = useState(false);
  const [four56CardWinner, setFour56CardWinner] = useState(false);
  const [eight910CardWinner, setEight910CardWinner] = useState(false);
  const [jQKCardWinner, setJQKCardWinner] = useState(false);

  const [oneCardWinner, setOneCardWinner] = useState(false);
  const [twoCardWinner, setTwoCardWinner] = useState(false);
  const [threeCardWinner, setThreeCardWinner] = useState(false);
  const [fourCardWinner, setFourCardWinner] = useState(false);
  const [fiveCardWinner, setFiveCardWinner] = useState(false);
  const [sixCardWinner, setSixCardWinner] = useState(false);
  const [sevenCardWinner, setSevenCardWinner] = useState(false);
  const [eightCardWinner, setEightCardWinner] = useState(false);
  const [nineCardWinner, setNineCardWinner] = useState(false);
  const [tenCardWinner, setTenCardWinner] = useState(false);
  const [elevenCardWinner, setElevenCardWinner] = useState(false);
  const [twelveCardWinner, setTwelveCardWinner] = useState(false);
  const [thirteenCardWinner, setThirteenCardWinner] = useState(false);

  const [resultData, setResultData] = useState([]);
  /* ================= TIMER ================= */
  const TOTAL_SECONDS = 30;
  const [timeLeft, setTimeLeft] = useState(TOTAL_SECONDS);
  const localTimerRef = useRef(null);

  /* ================= SINGLE CARD STATE ================= */
  const [shownCard, setShownCard] = useState("1");
  const [shouldFlip, setShouldFlip] = useState(false);
  const lastEvtStatusRef = useRef(null);

  /* ================= SOCKET ================= */
  const { data } = useSocket({
    marketId: null,
    mtype: "teenpatti",
    type: "lucky7second_virtual"
  });

  const payload = data?.data?.data;
  const { isSuspended, suspendedText } = useClosedPhaseOverlay(
    payload?.evt_status,
    payload?.cat_mid,
    setShowBetSlipPopup
  );
  const payloadResult = data?.data?.result;
  //console.log("data:", payload); // DO NOT REMOVE
  //console.log("payloadResult:", payloadResult); // DO NOT REMOVE
  /* ================= TIMER + VALUES ================= */

  const sessionUser = useSelector((s) => s.userStore.data);
  const updateUserData = async (userData) => {
    if (!userData || !sessionUser) return;
    await dispatch(
      setUserData({
        ...sessionUser,
        fname: userData.fname ?? sessionUser.fname,
        uname: userData.uname ?? sessionUser.uname,
        bz_balance: userData.bz_balance ?? sessionUser.bz_balance,
        opin_bal: userData.opin_bal ?? sessionUser.opin_bal,
        user_role: sessionUser.user_role,
        _id: sessionUser._id
      })
    );
  };
  useEffect(() => {
    if (!payload) return;

    setDisplayLoader(false);
    updateUserData(data?.user);

    if (lastStatus !== payload.evt_status && payload.evt_status === "OPEN") {
      setPlacedBets([]);
      setLowCardBook({ back: 0, lay: 0 });
      setHighCardBook({ back: 0, lay: 0 });
      setOddCardBook({ back: 0, lay: 0 });
      setEvenCardBook({ back: 0, lay: 0 });
      setRedCardBook({ back: 0, lay: 0 });
      setBlackCardBook({ back: 0, lay: 0 });
      setClubCardBook({ back: 0, lay: 0 });
      setDiamondCardBook({ back: 0, lay: 0 });
      setHeartCardBook({ back: 0, lay: 0 });
      setSpadeCardBook({ back: 0, lay: 0 });
      setA23CardBook({ back: 0, lay: 0 });
      setFour56CardBook({ back: 0, lay: 0 });
      setEight910CardBook({ back: 0, lay: 0 });
      setJQKCardBook({ back: 0, lay: 0 });
      setOneCardBook({ back: 0, lay: 0 });
      setTwoCardBook({ back: 0, lay: 0 });
      setThreeCardBook({ back: 0, lay: 0 });
      setFourCardBook({ back: 0, lay: 0 });
      setFiveCardBook({ back: 0, lay: 0 });
      setSixCardBook({ back: 0, lay: 0 });
      setSevenCardBook({ back: 0, lay: 0 });
      setEightCardBook({ back: 0, lay: 0 });
      setNineCardBook({ back: 0, lay: 0 });
      setTenCardBook({ back: 0, lay: 0 });
      setElevenCardBook({ back: 0, lay: 0 });
      setTwelveCardBook({ back: 0, lay: 0 });
      setThirteenCardBook({ back: 0, lay: 0 });

      setLowCardWinner(false);
      setHighCardWinner(false);
      setOddCardWinner(false);
      setEvenCardWinner(false);
      setRedCardWinner(false);
      setBlackCardWinner(false);
      setClubCardWinner(false);
      setHeartCardWinner(false);
      setSpadeCardWinner(false);
      setDiamondCardWinner(false);

      setA23CardWinner(false);
      setFour56CardWinner(false);
      setEight910CardWinner(false);
      setJQKCardWinner(false);

      setOneCardWinner(false);
      setTwoCardWinner(false);
      setThreeCardWinner(false);
      setFourCardWinner(false);
      setFiveCardWinner(false);
      setSixCardWinner(false);
      setSevenCardWinner(false);
      setEightCardWinner(false);
      setNineCardWinner(false);
      setTenCardWinner(false);
      setElevenCardWinner(false);
      setTwelveCardWinner(false);
      setThirteenCardWinner(false);
    }

    if (lastStatus !== payload.evt_status) {
      setLastStatus(payload.evt_status);
    }

    setLowCard(payload?.b4);
    setHighCard(payload?.b4);
    setOddCard(payload?.b6);
    setEvenCard(payload?.b7);
    setRedCard(payload?.b4);
    setBlackCard(payload?.b4);
    setSuitCard(payload?.b8);
    setThreeCard(payload?.b12);
    setSingleCard(payload?.b13);
    setSingleCard(payload?.b13);
    setSuspend1(payload?.suspend1);
    setRoundId(payload?.cat_mid);

    const serverSeconds = payload?.left_time;
    if (typeof serverSeconds === "number") {
      setTimeLeft(serverSeconds);
    }

    if (payload?.result !== "") {
      let resultVal = payload?.result;
      let cardValue = payload?.c1;
      if (resultVal == 1) {
        setLowCardWinner(true);
      } else {
        setHighCardWinner(true);
      }

      let lastTwo = cardValue.slice(-2);
      if (lastTwo == "HH" || lastTwo == "CC") {
        setBlackCardWinner(true);
      } else {
        setRedCardWinner(true);
      }

      if (lastTwo == "HH") {
        setSpadeCardWinner(true);
      } else if (lastTwo == "CC") {
        setClubCardWinner(true);
      } else if (lastTwo == "DD") {
        setHeartCardWinner(true);
      } else if (lastTwo == "SS") {
        setDiamondCardWinner(true);
      }

      let removeLastTwo = cardValue.slice(0, -2);
      if (removeLastTwo == "K") {
        removeLastTwo = 13;
      } else if (removeLastTwo == "Q") {
        removeLastTwo = 12;
      } else if (removeLastTwo == "J") {
        removeLastTwo = 11;
      } else if (removeLastTwo == "A") {
        removeLastTwo = 1;
      }

      if (removeLastTwo % 2 == 0) {
        setEvenCardWinner(true);
      } else {
        setOddCardWinner(true);
      }

      if (removeLastTwo == 1 || removeLastTwo == 2 || removeLastTwo == 3) {
        setA23CardWinner(true);
      } else if (
        removeLastTwo == 4 ||
        removeLastTwo == 5 ||
        removeLastTwo == 6
      ) {
        setFour56CardWinner(true);
      } else if (
        removeLastTwo == 8 ||
        removeLastTwo == 9 ||
        removeLastTwo == 10
      ) {
        setEight910CardWinner(true);
      } else if (
        removeLastTwo == 11 ||
        removeLastTwo == 12 ||
        removeLastTwo == 13
      ) {
        setJQKCardWinner(true);
      }

      if (removeLastTwo == 1) {
        setOneCardWinner(true);
      } else if (removeLastTwo == 2) {
        setTwoCardWinner(true);
      } else if (removeLastTwo == 3) {
        setThreeCardWinner(true);
      } else if (removeLastTwo == 4) {
        setFourCardWinner(true);
      } else if (removeLastTwo == 5) {
        setFiveCardWinner(true);
      } else if (removeLastTwo == 6) {
        setSixCardWinner(true);
      } else if (removeLastTwo == 7) {
        setSevenCardWinner(true);
      } else if (removeLastTwo == 8) {
        setEightCardWinner(true);
      } else if (removeLastTwo == 9) {
        setNineCardWinner(true);
      } else if (removeLastTwo == 10) {
        setTenCardWinner(true);
      } else if (removeLastTwo == 11) {
        setElevenCardWinner(true);
      } else if (removeLastTwo == 12) {
        setTwelveCardWinner(true);
      } else if (removeLastTwo == 13) {
        setThirteenCardWinner(true);
      }
    }

    clearInterval(localTimerRef.current);
    localTimerRef.current = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
  }, [payload]);

  useEffect(() => {
    if (!payloadResult) return;

    if (payloadResult !== "") {
      //console.log("payloadResult->", payloadResult);
      setResultList([]);
      setResultList(payloadResult);
    }
  }, [payloadResult]);

  useEffect(() => () => clearInterval(localTimerRef.current), []);

  /* ================= SINGLE CARD UPDATE + FLIP ================= */
  useEffect(() => {
    if (!payload?.evt_status) return;

    if (lastEvtStatusRef.current === payload.evt_status) return;
    lastEvtStatusRef.current = payload.evt_status;

    if (payload?.c1) {
      setShownCard(payload.c1);
    }

    if (payload.evt_status === "CLOSED") {
      setShouldFlip(true);
    } else {
      setShouldFlip(false);
    }
  }, [payload?.evt_status]);

  /* ================= SVG TIMER ================= */
  const R = 45;
  const CIRC = 2 * Math.PI * R;
  const dash = Math.max(0.0001, CIRC * (timeLeft / TOTAL_SECONDS));
  const timerColor =
    timeLeft <= 5 ? "red" : timeLeft <= 10 ? "orange" : "green";

  /* ================= BET SLIP ================= */
  const activeTab = async (tab1) => {
    setActiveTabIndex(tab1);
    if (tab1 == 2) {
      showResultDetail();
    }
  };
  const showBetfairBetSlip = (
    bettype,
    teamname,
    selectRnr,
    price,
    marketTypeVal,
    sid
  ) => {
    let obj = {
      amount: 0,
      catmid: payload?.cat_mid,
      round: payload?.cat_mid,
      odds: price,
      teamname,
      bettype,
      selectRnr,
      marketVal: 1,
      game_type: 7,
      game_name: "lucky7second_virtual",
      market_type: marketTypeVal,
      sid: sid
    };

    setPlaceBetObject(obj);
    if (isMobile) {
      setShowBetSlipPopup(true);
    } else {
      setShowBetSlip(true);
    }
  };

  const closeBetSlip = () => setShowBetSlip(false);

  const [profileData, setProfileData] = useState(null);
  const [placedBets, setPlacedBets] = useState([]);
  const [initialBetsFetched, setInitialBetsFetched] = useState(false);

  const fetchProfile = async () => {
    const { data } = await axiosInstance.get("/profile");
    setProfileData(data);
  };

  const betStakeLimit = async () => {
    try {
      const { data } = await axiosInstance.get("/profile/bet-stake-limit");
      if (data != null && data !== undefined) {
        let limit = data?.myBetLimit?.teenpatiStudio;
        setStakeLimit(formatTruncate(limit));
      }
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  const closeBetSlipMobile = () => {
    setShowBetSlipPopup(false);
    setBetErrorMessage({});
  };

  async function getPlacedBets() {
    if (!payload?.cat_mid) return;
    const res = await axiosInstance.post("/casino/get-placed-bets", {
      cat_mid: payload.cat_mid,
      gametype: "lucky7second_virtual"
    });
    setPlacedBets(res.data);
  }

  useEffect(() => {
    fetchProfile();
    betStakeLimit();
  }, []);

  useEffect(() => {
    if (!initialBetsFetched && payload?.cat_mid) {
      getPlacedBets();
      getBook();
      setInitialBetsFetched(true);
    }
  }, [payload]);

  async function getBook() {
    if (!payload?.cat_mid) return;
    const res = await axiosInstance.post("/casino/get-book", {
      cat_mid: payload.cat_mid,
      gametype: "lucky7second_virtual"
    });
    let responseData = res?.data;
    if (responseData != null && responseData.length > 0) {
      responseData.map((currentValue, index, arr) => {
        if (currentValue.name == "low card") {
          setLowCardBook({ back: currentValue.back, lay: currentValue.lay });
        } else if (currentValue.name == "high card") {
          setHighCardBook({ back: currentValue.back, lay: currentValue.lay });
        } else if (currentValue.name == "odd") {
          setOddCardBook({ back: currentValue.back, lay: currentValue.lay });
        } else if (currentValue.name == "even") {
          setEvenCardBook({ back: currentValue.back, lay: currentValue.lay });
        } else if (currentValue.name == "red") {
          setRedCardBook({ back: currentValue.back, lay: currentValue.lay });
        } else if (currentValue.name == "black") {
          setBlackCardBook({ back: currentValue.back, lay: currentValue.lay });
        } else if (currentValue.name == "club") {
          setClubCardBook({ back: currentValue.back, lay: currentValue.lay });
        } else if (currentValue.name == "diamond") {
          setDiamondCardBook({
            back: currentValue.back,
            lay: currentValue.lay
          });
        } else if (currentValue.name == "heart") {
          setHeartCardBook({ back: currentValue.back, lay: currentValue.lay });
        } else if (currentValue.name == "spade") {
          setSpadeCardBook({ back: currentValue.back, lay: currentValue.lay });
        } else if (currentValue.name == "456") {
          setFour56CardBook({ back: currentValue.back, lay: currentValue.lay });
        } else if (currentValue.name == "8910") {
          setEight910CardBook({
            back: currentValue.back,
            lay: currentValue.lay
          });
        } else if (currentValue.name == "jqk") {
          setJQKCardBook({ back: currentValue.back, lay: currentValue.lay });
        } else if (currentValue.name == "card 1") {
          setOneCardBook({ back: currentValue.back, lay: currentValue.lay });
        } else if (currentValue.name == "card 2") {
          setTwoCardBook({ back: currentValue.back, lay: currentValue.lay });
        } else if (currentValue.name == "card 3") {
          setThreeCardBook({ back: currentValue.back, lay: currentValue.lay });
        } else if (currentValue.name == "card 4") {
          setFourCardBook({ back: currentValue.back, lay: currentValue.lay });
        } else if (currentValue.name == "card 5") {
          setFiveCardBook({ back: currentValue.back, lay: currentValue.lay });
        } else if (currentValue.name == "card 6") {
          setSixCardBook({ back: currentValue.back, lay: currentValue.lay });
        } else if (currentValue.name == "card 7") {
          setSevenCardBook({ back: currentValue.back, lay: currentValue.lay });
        } else if (currentValue.name == "card 8") {
          setEightCardBook({ back: currentValue.back, lay: currentValue.lay });
        } else if (currentValue.name == "card 9") {
          setNineCardBook({ back: currentValue.back, lay: currentValue.lay });
        } else if (currentValue.name == "card 10") {
          setTenCardBook({ back: currentValue.back, lay: currentValue.lay });
        } else if (currentValue.name == "card 11") {
          setElevenCardBook({ back: currentValue.back, lay: currentValue.lay });
        } else if (currentValue.name == "card 12") {
          setTwelveCardBook({ back: currentValue.back, lay: currentValue.lay });
        } else if (currentValue.name == "card 13") {
          setThirteenCardBook({
            back: currentValue.back,
            lay: currentValue.lay
          });
        }
      });
    }
    //console.log("responseData->", responseData);
  }

  const placeBet = async (amount, profit) => {
    placeBetObject.amount = amount;
    placeBetObject.profit = profit;
    // placeBetObject.sid1 = payload?.sid1;
    // placeBetObject.sid2 = payload?.sid2;
    // placeBetObject.sid3 = payload?.sid3;

    try {
      const response = await axiosInstance.post(
        "/casino/place-bet-casino",
        placeBetObject
      );

      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data.status !== undefined &&
        response.data.status !== null
      ) {
        let messageObj = {};
        if (response.data.status) {
          messageObj.status = true;
          getPlacedBets();
          getBook();
          setShowBetSlipPopup(false);
        } else {
          messageObj.status = false;
        }
        messageObj.message = response.data.message;
        setBetErrorMessage(messageObj);
      }
    } catch (error) {
      if (error.response.data !== undefined && error.response.data !== null) {
        if (
          error.response.data.status !== undefined &&
          error.response.data.status !== null &&
          error.response.data.status === false
        ) {
          let errorMessage = error.response.data.message;
          let messageObj = {};
          messageObj.status = false;
          messageObj.message = errorMessage;
          setBetErrorMessage(messageObj);
        }
      }
    }
  };

  const displayRunnerName = (runnerName) => {
    return runnerName
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  /// result detail ///
  const showResultDetail = async () => {
    let resultObj = {};
    resultObj.game_type = "lucky7second_virtual";

    const response = await axiosInstance.post("/teenpatti-results", resultObj);

    setResultData(response.data.results_list);
    //console.log("response->", resultData);
  };
  /// result detail ///

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  return (
    <div className="lucky7second-scope aviator-scope player-scope aviator-bg-black">
      <ClientLayoutWithOutHeader showLoader={false}>
        <div class="details-tabs-wrapper1">
          <div className="main-page">
            <div className="row no-gutters">
              <div className="col-md-12">
                <div className="bodyheight">
                  <div className="wrapper">
                    <TPStudioSidebar open={open} />
                  </div>

                  <div className="lobby-ctn BPGmaindiv">
                    <TpStudioHeader setOpen={setOpen} open={open} />
                    <TpStudioLoader displayLoader={displayLoader} />
                  </div>

                  <div
                    className="row"
                    style={{ display: displayLoader ? "none" : "" }}
                  >
                    <div className="col-md-8">
                      <div className="left-content margin-mob">
                        <div>
                          <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer h-45">
                            <div className="col-6 col-md-6 titlebarname  inline-block Gameidcol mt-2">
                              <p>LUCKY 7</p>
                            </div>
                            <div
                              className="col-6 col-md-6 inline-block Gameidcol text-right"
                              style={{ marginTop: "4px" }}
                            >
                              <div
                                role="group"
                                aria-label="Second group"
                                className="btn-group btn-group-sm mr-2"
                              >
                                <button
                                  style={{ fontSize: "14px" }}
                                  type="button"
                                  id="Alltab"
                                  className={
                                    activeTabIndex == 1
                                      ? "tablink btn btn-primary bbactive"
                                      : "tablink btn btn-primary"
                                  }
                                  onClick={() => activeTab(1)}
                                >
                                  Game
                                </button>
                                <button
                                  style={{ fontSize: "14px" }}
                                  type="button"
                                  id="RESULTStab"
                                  className={
                                    activeTabIndex == 2
                                      ? "tablink btn btn-primary bbactive"
                                      : "tablink btn btn-primary"
                                  }
                                  onClick={() => activeTab(2)}
                                >
                                  Results
                                </button>
                                <button
                                  style={{ fontSize: "14px" }}
                                  type="button"
                                  className="tablink btn btn-primary"
                                  onClick={() => setShowRules(true)}
                                >
                                  Rules
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="cards-layout blackjack"
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div>
                            <div
                              className="cards-layout blackjack"
                              style={{ position: "relative" }}
                            >
                              <div className="col-12 timerDiv2">
                                <LuckySecRules
                                  show={showRules}
                                  onClose={() => setShowRules(false)}
                                />

                                <div
                                  className="row mt-2"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                >
                                  <div className="col-2 col-md-1">
                                    <div className="Connectedclients mt-1">
                                      <i
                                        aria-hidden="true"
                                        className="fa fa-user mr-1"
                                        style={{
                                          fontSize: "14px",
                                          color: "white"
                                        }}
                                      />
                                      <b>
                                        <span
                                          id="UsersCount"
                                          className="number"
                                        >
                                          326
                                        </span>
                                      </b>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className="col-md-8"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                />

                                <div
                                  className="col-md-2"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                >
                                  {/* Timer with animated stroke + numeric countdown */}
                                  <div className="teenpatti-base-timer">
                                    <svg
                                      viewBox="0 0 100 100"
                                      className="base-timer__svg"
                                    >
                                      <g className="base-timer__circle">
                                        <circle
                                          cx="50"
                                          cy="50"
                                          r="45"
                                          className="base-timer__path-elapsed"
                                        />
                                        <path
                                          strokeDasharray={`${Math.round(
                                            dash
                                          )} ${Math.round(CIRC)}`}
                                          className={`base-timer__path-remaining ${timerColor}`}
                                          d="
                M 50, 50
                m -45, 0
                a 45,45 0 1,0 90,0
                a 45,45 0 1,0 -90,0
              "
                                        />
                                      </g>
                                    </svg>
                                    <span className="base-timer__label">
                                      {timeLeft == 1 ? 0 : timeLeft}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div
                                className="table-player mt-0"
                                style={{
                                  display: activeTabIndex == 1 ? "" : "none"
                                }}
                              >
                                <span className="name player-dt">Winner </span>
                                <div className="player player-card lucky7second-player-card">
                                  <div className="tp-hand-single">
                                    <div
                                      className={`tp-card ${
                                        !isMobile &&
                                        shouldFlip &&
                                        payload?.c1 != "1"
                                          ? "flip"
                                          : ""
                                      }`}
                                    >
                                      <img
                                        src={`/assets/images/cards/${payload?.c1}.svg`}
                                        draggable={false}
                                        alt=""
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <Volume
                                id="Lucky7SecondSoundcontrol"
                                style={{
                                  position: "absolute",
                                  right: 8,
                                  bottom: 8,
                                  zIndex: 100,
                                  display: activeTabIndex == 1 ? "" : "none"
                                }}
                              />
                              {/* Controls removed (auto mode) */}
                            </div>
                          </div>
                        </div>

                        {/* Footer */}
                        <center
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer">
                            <div className="buttons-div">
                              {Object.keys(resultList).map((idx) => (
                                <button
                                  key={idx}
                                  className="video-button border-gradient-btn border-gradient-purple-btn"
                                >
                                  {resultList[idx]}
                                </button>
                              ))}
                            </div>
                            <div className="round-div">
                              <div className="label">Round ID:</div>
                              <div className="id">{roundId}</div>
                            </div>
                          </div>
                        </center>

                        {/* Market Sections (unchanged) */}
                        <div
                          className="bg-white"
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div
                            className="tb-content"
                            style={{ background: "#fff" }}
                          >
                            <div
                              class="tb-content"
                              style={{ background: "#fff" }}
                            >
                              <div class="market-titlebar">
                                <p class="market-name">
                                  <span class="market-name-badge">
                                    <i class="market-name-icon">
                                      <img
                                        src="/assets/images/time-img.png"
                                        style={{
                                          filter: "invert(100%)",
                                          marginTop: "-8px",
                                          marginLeft: "-1px"
                                        }}
                                      />
                                    </i>
                                    <span>MATCH ODDS </span>
                                  </span>
                                </p>
                                <div class="market-overarround">
                                  <span></span>
                                  <strong>Back</strong>
                                </div>
                                <div class="market-overarround market-overarround-lay">
                                  <strong>Lay</strong>
                                </div>
                              </div>
                              <div class="market-runners">
                                <div class="runner-runner">
                                  <h3
                                    className={
                                      lowCardWinner
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Low Card
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="book1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      lowCardBook.back > 0
                                                        ? ""
                                                        : "none"
                                                  }}
                                                >
                                                  <span
                                                    style={{ color: "green" }}
                                                  >
                                                    {formatTruncate(
                                                      lowCardBook.back
                                                    )}
                                                  </span>
                                                  /
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    {formatTruncate(
                                                      lowCardBook.lay
                                                    )}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="low card"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "low card",
                                          "low card",
                                          LowCard,
                                          "m",
                                          1
                                        )
                                      }
                                    >
                                      <div id="rnr1" class="sus_cls">
                                        <span
                                          class="price-odd odd"
                                          id="runnerlowspan"
                                        >
                                          {LowCard}
                                        </span>
                                        <span class="price-amount" id="rate1">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      highCardWinner
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  High Card
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="book1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      highCardBook.back > 0
                                                        ? ""
                                                        : "none"
                                                  }}
                                                >
                                                  <span
                                                    style={{ color: "green" }}
                                                  >
                                                    {formatTruncate(
                                                      highCardBook.back
                                                    )}
                                                  </span>
                                                  /
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    {formatTruncate(
                                                      highCardBook.lay
                                                    )}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="high card"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "high card",
                                          "high card",
                                          highCard,
                                          "m",
                                          1
                                        )
                                      }
                                    >
                                      <div id="rnr2" class="sus_cls">
                                        <span
                                          class="price-odd odd"
                                          id="runnerhighspan"
                                        >
                                          {highCard}
                                        </span>
                                        <span class="price-amount" id="rate2">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              style={{ height: "5px", backgroundColor: "#000" }}
                            ></div>

                            <div
                              class="tb-content"
                              style={{ background: "#fff" }}
                            >
                              <div class="market-titlebar">
                                <p class="market-name">
                                  <span class="market-name-badge">
                                    <i class="market-name-icon">
                                      <img
                                        src="/assets/images/time-img.png"
                                        style={{
                                          filter: "invert(100%)",
                                          marginTop: "-8px",
                                          marginLeft: "-1px"
                                        }}
                                      />
                                    </i>
                                    <span>ODD-EVEN </span>
                                  </span>
                                </p>
                                <div class="market-overarround">
                                  <span></span>
                                  <strong>Back</strong>
                                </div>
                                <div class="market-overarround market-overarround-lay">
                                  <strong>Lay</strong>
                                </div>
                              </div>
                              <div class="market-runners">
                                <div class="runner-runner">
                                  <h3
                                    className={
                                      evenCardWinner
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Even
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="book1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      evenCardBook.back > 0
                                                        ? ""
                                                        : "none"
                                                  }}
                                                >
                                                  <span
                                                    style={{ color: "green" }}
                                                  >
                                                    {formatTruncate(
                                                      evenCardBook.back
                                                    )}
                                                  </span>
                                                  /
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    {formatTruncate(
                                                      evenCardBook.lay
                                                    )}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="even"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "even",
                                          "even",
                                          evenCard,
                                          "m",
                                          1
                                        )
                                      }
                                    >
                                      <div id="rnr7" class="sus_cls">
                                        <span
                                          class="price-odd odd"
                                          id="runnerevenspan"
                                        >
                                          {evenCard}
                                        </span>
                                        <span class="price-amount" id="rate7">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      oddCardWinner
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Odd
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="book1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      oddCardBook.back > 0
                                                        ? ""
                                                        : "none"
                                                  }}
                                                >
                                                  <span
                                                    style={{ color: "green" }}
                                                  >
                                                    {formatTruncate(
                                                      oddCardBook.back
                                                    )}
                                                  </span>
                                                  /
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    {formatTruncate(
                                                      oddCardBook.lay
                                                    )}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="odd"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "odd",
                                          "odd",
                                          oddCard,
                                          "m",
                                          1
                                        )
                                      }
                                    >
                                      <div id="rnr6" class="sus_cls">
                                        <span
                                          class="price-odd odd"
                                          id="runneroddspan"
                                        >
                                          {oddCard}
                                        </span>
                                        <span class="price-amount" id="rate6">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              style={{ height: "5px", backgroundColor: "#000" }}
                            ></div>

                            <div
                              class="tb-content"
                              style={{ background: "#fff" }}
                            >
                              <div class="market-titlebar">
                                <p class="market-name">
                                  <span class="market-name-badge">
                                    <i class="market-name-icon">
                                      <img
                                        src="/assets/images/time-img.png"
                                        style={{
                                          filter: "invert(100%)",
                                          marginTop: "-8px",
                                          marginLeft: "-1px"
                                        }}
                                      />
                                    </i>
                                    <span>COLOR </span>
                                  </span>
                                </p>
                                <div class="market-overarround">
                                  <span></span>
                                  <strong>Back</strong>
                                </div>
                                <div class="market-overarround market-overarround-lay">
                                  <strong>Lay</strong>
                                </div>
                              </div>
                              <div class="market-runners">
                                <div class="runner-runner">
                                  <h3
                                    className={
                                      redCardWinner
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Red
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="book1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      redCardBook.back > 0
                                                        ? ""
                                                        : "none"
                                                  }}
                                                >
                                                  <span
                                                    style={{ color: "green" }}
                                                  >
                                                    {formatTruncate(
                                                      redCardBook.back
                                                    )}
                                                  </span>
                                                  /
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    {formatTruncate(
                                                      redCardBook.lay
                                                    )}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="red"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "red",
                                          "red",
                                          redCard,
                                          "m",
                                          1
                                        )
                                      }
                                    >
                                      <div id="rnr4" class="sus_cls">
                                        <span
                                          class="price-odd odd"
                                          id="runnerredspan"
                                        >
                                          {redCard}
                                        </span>
                                        <span class="price-amount" id="rate4">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      blackCardWinner
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Black
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="book1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      blackCardBook.back > 0
                                                        ? ""
                                                        : "none"
                                                  }}
                                                >
                                                  <span
                                                    style={{ color: "green" }}
                                                  >
                                                    {formatTruncate(
                                                      blackCardBook.back
                                                    )}
                                                  </span>
                                                  /
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    {formatTruncate(
                                                      blackCardBook.lay
                                                    )}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="black"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "black",
                                          "black",
                                          blackCard,
                                          "m",
                                          1
                                        )
                                      }
                                    >
                                      <div id="rnr5" class="sus_cls">
                                        <span
                                          class="price-odd odd"
                                          id="runnerblackspan"
                                        >
                                          {blackCard}
                                        </span>
                                        <span class="price-amount" id="rate5">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              style={{ height: "5px", backgroundColor: "#000" }}
                            ></div>

                            <div
                              class="tb-content"
                              style={{ background: "#fff" }}
                            >
                              <div class="market-titlebar">
                                <p class="market-name">
                                  <span class="market-name-badge">
                                    <i class="market-name-icon">
                                      <img
                                        src="/assets/images/time-img.png"
                                        style={{
                                          filter: "invert(100%)",
                                          marginTop: "-8px",
                                          marginLeft: "-1px"
                                        }}
                                      />
                                    </i>
                                    <span>SUIT </span>
                                  </span>
                                </p>
                                <div class="market-overarround">
                                  <span></span>
                                  <strong>Back</strong>
                                </div>
                                <div class="market-overarround market-overarround-lay">
                                  <strong>Lay</strong>
                                </div>
                              </div>
                              <div class="market-runners">
                                <div class="runner-runner">
                                  <h3
                                    className={
                                      clubCardWinner
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Club
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="book1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      clubCardBook.back > 0
                                                        ? ""
                                                        : "none"
                                                  }}
                                                >
                                                  <span
                                                    style={{ color: "green" }}
                                                  >
                                                    {formatTruncate(
                                                      clubCardBook.back
                                                    )}
                                                  </span>
                                                  /
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    {formatTruncate(
                                                      clubCardBook.lay
                                                    )}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="club"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "club",
                                          "club",
                                          suitCard,
                                          "m",
                                          1
                                        )
                                      }
                                    >
                                      <div id="rnr8" class="sus_cls">
                                        <span
                                          class="price-odd odd"
                                          id="runnerclubspan"
                                        >
                                          {suitCard}
                                        </span>
                                        <span class="price-amount" id="rate8">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      diamondCardWinner
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Diamond
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="book1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      diamondCardBook.back > 0
                                                        ? ""
                                                        : "none"
                                                  }}
                                                >
                                                  <span
                                                    style={{ color: "green" }}
                                                  >
                                                    {formatTruncate(
                                                      diamondCardBook.back
                                                    )}
                                                  </span>
                                                  /
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    {formatTruncate(
                                                      diamondCardBook.lay
                                                    )}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="diamond"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "diamond",
                                          "diamond",
                                          suitCard,
                                          "m",
                                          1
                                        )
                                      }
                                    >
                                      <div id="rnr9" class="sus_cls">
                                        <span
                                          class="price-odd odd"
                                          id="runnerdiamondspan"
                                        >
                                          {suitCard}
                                        </span>
                                        <span class="price-amount" id="rate9">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      heartCardWinner
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Heart
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="book1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      heartCardBook.back > 0
                                                        ? ""
                                                        : "none"
                                                  }}
                                                >
                                                  <span
                                                    style={{ color: "green" }}
                                                  >
                                                    {formatTruncate(
                                                      heartCardBook.back
                                                    )}
                                                  </span>
                                                  /
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    {formatTruncate(
                                                      heartCardBook.lay
                                                    )}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="heart"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "heart",
                                          "heart",
                                          suitCard,
                                          "m",
                                          1
                                        )
                                      }
                                    >
                                      <div id="rnr10" class="sus_cls">
                                        <span
                                          class="price-odd odd"
                                          id="runnerheartspan"
                                        >
                                          {suitCard}
                                        </span>
                                        <span class="price-amount" id="rate10">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      spadeCardWinner
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Spade
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="book1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      spadeCardBook.back > 0
                                                        ? ""
                                                        : "none"
                                                  }}
                                                >
                                                  <span
                                                    style={{ color: "green" }}
                                                  >
                                                    {formatTruncate(
                                                      spadeCardBook.back
                                                    )}
                                                  </span>
                                                  /
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    {formatTruncate(
                                                      spadeCardBook.lay
                                                    )}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="spade"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "spade",
                                          "spade",
                                          suitCard,
                                          "m",
                                          1
                                        )
                                      }
                                    >
                                      <div id="rnr11" class="sus_cls">
                                        <span
                                          class="price-odd odd"
                                          id="runnerspadespan"
                                        >
                                          {suitCard}
                                        </span>
                                        <span class="price-amount" id="rate11">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              style={{ height: "5px", backgroundColor: "#000" }}
                            ></div>

                            <div
                              class="tb-content"
                              style={{ background: "#fff" }}
                            >
                              <div class="market-titlebar">
                                <p class="market-name">
                                  <span class="market-name-badge">
                                    <i class="market-name-icon">
                                      <img
                                        src="/assets/images/time-img.png"
                                        style={{
                                          filter: "invert(100%)",
                                          marginTop: "-8px",
                                          marginLeft: "-1px"
                                        }}
                                      />
                                    </i>
                                    <span>3 CARD </span>
                                  </span>
                                </p>
                                <div class="market-overarround">
                                  <span></span>
                                  <strong>Back</strong>
                                </div>
                                <div class="market-overarround market-overarround-lay">
                                  <strong>Lay</strong>
                                </div>
                              </div>
                              <div class="market-runners">
                                <div class="runner-runner">
                                  <h3
                                    className={
                                      A23CardWinner
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  A23
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="book1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      A23CardBook.back > 0
                                                        ? ""
                                                        : "none"
                                                  }}
                                                >
                                                  <span
                                                    style={{ color: "green" }}
                                                  >
                                                    {formatTruncate(
                                                      A23CardBook.back
                                                    )}
                                                  </span>
                                                  /
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    {formatTruncate(
                                                      A23CardBook.lay
                                                    )}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="a23"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "a23",
                                          "a23",
                                          threeCard,
                                          "m",
                                          1
                                        )
                                      }
                                    >
                                      <div id="rnr12" class="sus_cls">
                                        <span class="price-odd odd" id="b12">
                                          {threeCard}
                                        </span>
                                        <span class="price-amount" id="rate12">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      four56CardWinner
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  456
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="book1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      four56CardBook.back > 0
                                                        ? ""
                                                        : "none"
                                                  }}
                                                >
                                                  <span
                                                    style={{ color: "green" }}
                                                  >
                                                    {formatTruncate(
                                                      four56CardBook.back
                                                    )}
                                                  </span>
                                                  /
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    {formatTruncate(
                                                      four56CardBook.lay
                                                    )}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="456"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "456",
                                          "456",
                                          threeCard,
                                          "m",
                                          1
                                        )
                                      }
                                    >
                                      <div id="rnr13" class="sus_cls">
                                        <span class="price-odd odd" id="b13">
                                          {threeCard}
                                        </span>
                                        <span class="price-amount" id="rate13">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      eight910CardWinner
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  8910
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="book1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      eight910CardBook.back > 0
                                                        ? ""
                                                        : "none"
                                                  }}
                                                >
                                                  <span
                                                    style={{ color: "green" }}
                                                  >
                                                    {formatTruncate(
                                                      eight910CardBook.back
                                                    )}
                                                  </span>
                                                  /
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    {formatTruncate(
                                                      eight910CardBook.lay
                                                    )}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="8910"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "8910",
                                          "8910",
                                          threeCard,
                                          "m",
                                          1
                                        )
                                      }
                                    >
                                      <div id="rnr14" class="sus_cls">
                                        <span class="price-odd odd" id="b14">
                                          {threeCard}
                                        </span>
                                        <span class="price-amount" id="rate14">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      jQKCardWinner
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  JQK
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="book1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      jQKCardBook.back > 0
                                                        ? ""
                                                        : "none"
                                                  }}
                                                >
                                                  <span
                                                    style={{ color: "green" }}
                                                  >
                                                    {formatTruncate(
                                                      jQKCardBook.back
                                                    )}
                                                  </span>
                                                  /
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    {formatTruncate(
                                                      jQKCardBook.lay
                                                    )}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="jqk"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "jqk",
                                          "jqk",
                                          threeCard,
                                          "m",
                                          1
                                        )
                                      }
                                    >
                                      <div id="rnr15" class="sus_cls">
                                        <span class="price-odd odd" id="b15">
                                          {threeCard}
                                        </span>
                                        <span class="price-amount" id="rate15">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              style={{ height: "5px", backgroundColor: "#000" }}
                            ></div>

                            <div
                              class="tb-content"
                              style={{ background: "#fff" }}
                            >
                              <div class="market-titlebar">
                                <p class="market-name">
                                  <span class="market-name-badge">
                                    <i class="market-name-icon">
                                      <img
                                        src="/assets/images/time-img.png"
                                        style={{
                                          filter: "invert(100%)",
                                          marginTop: "-8px",
                                          marginLeft: "-1px"
                                        }}
                                      />
                                    </i>
                                    <span>CARD </span>
                                  </span>
                                </p>
                                <div class="market-overarround">
                                  <span></span>
                                  <strong>Back</strong>
                                </div>
                                <div class="market-overarround market-overarround-lay">
                                  <strong>Lay</strong>
                                </div>
                              </div>
                              <div class="market-runners">
                                <div class="runner-runner">
                                  <h3
                                    className={
                                      oneCardWinner
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  A
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="book1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      oneCardBook.back > 0
                                                        ? ""
                                                        : "none"
                                                  }}
                                                >
                                                  <span
                                                    style={{ color: "green" }}
                                                  >
                                                    {formatTruncate(
                                                      oneCardBook.back
                                                    )}
                                                  </span>
                                                  /
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    {formatTruncate(
                                                      oneCardBook.lay
                                                    )}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="card 1"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "card 1",
                                          "card 1",
                                          singleCard,
                                          "m",
                                          1
                                        )
                                      }
                                    >
                                      <div id="rnr16" class="sus_cls">
                                        <span
                                          class="price-odd odd"
                                          id="runnercardspancard1"
                                        >
                                          {singleCard}
                                        </span>
                                        <span class="price-amount" id="rate16">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      twoCardWinner
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  2
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="book1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      twoCardBook.back > 0
                                                        ? ""
                                                        : "none"
                                                  }}
                                                >
                                                  <span
                                                    style={{ color: "green" }}
                                                  >
                                                    {formatTruncate(
                                                      twoCardBook.back
                                                    )}
                                                  </span>
                                                  /
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    {formatTruncate(
                                                      twoCardBook.lay
                                                    )}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="card 2"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "card 2",
                                          "card 2",
                                          singleCard,
                                          "m",
                                          1
                                        )
                                      }
                                    >
                                      <div id="rnr17" class="sus_cls">
                                        <span
                                          class="price-odd odd"
                                          id="runnercardspancard2"
                                        >
                                          {singleCard}
                                        </span>
                                        <span class="price-amount" id="rate17">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      threeCardWinner
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  3
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="book1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      threeCardBook.back > 0
                                                        ? ""
                                                        : "none"
                                                  }}
                                                >
                                                  <span
                                                    style={{ color: "green" }}
                                                  >
                                                    {formatTruncate(
                                                      threeCardBook.back
                                                    )}
                                                  </span>
                                                  /
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    {formatTruncate(
                                                      threeCardBook.lay
                                                    )}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="card 3"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "card 3",
                                          "card 3",
                                          singleCard,
                                          "m",
                                          1
                                        )
                                      }
                                    >
                                      <div id="rnr18" class="sus_cls">
                                        <span
                                          class="price-odd odd"
                                          id="runnercardspancard3"
                                        >
                                          {singleCard}
                                        </span>
                                        <span class="price-amount" id="rate18">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      fourCardWinner
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  4
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="book1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      fourCardBook.back > 0
                                                        ? ""
                                                        : "none"
                                                  }}
                                                >
                                                  <span
                                                    style={{ color: "green" }}
                                                  >
                                                    {formatTruncate(
                                                      fourCardBook.back
                                                    )}
                                                  </span>
                                                  /
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    {formatTruncate(
                                                      fourCardBook.lay
                                                    )}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="card 4"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "card 4",
                                          "card 4",
                                          singleCard,
                                          "m",
                                          1
                                        )
                                      }
                                    >
                                      <div id="rnr19" class="sus_cls">
                                        <span
                                          class="price-odd odd"
                                          id="runnercardspancard4"
                                        >
                                          {singleCard}
                                        </span>
                                        <span class="price-amount" id="rate19">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      fiveCardWinner
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  5
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="book1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      fiveCardBook.back > 0
                                                        ? ""
                                                        : "none"
                                                  }}
                                                >
                                                  <span
                                                    style={{ color: "green" }}
                                                  >
                                                    {formatTruncate(
                                                      fiveCardBook.back
                                                    )}
                                                  </span>
                                                  /
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    {formatTruncate(
                                                      fiveCardBook.lay
                                                    )}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="card 5"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "card 5",
                                          "card 5",
                                          singleCard,
                                          "m",
                                          1
                                        )
                                      }
                                    >
                                      <div id="rnr20" class="sus_cls">
                                        <span
                                          class="price-odd odd"
                                          id="runnercardspancard5"
                                        >
                                          {singleCard}
                                        </span>
                                        <span class="price-amount" id="rate20">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      sixCardWinner
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  6
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="book1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      sixCardBook.back > 0
                                                        ? ""
                                                        : "none"
                                                  }}
                                                >
                                                  <span
                                                    style={{ color: "green" }}
                                                  >
                                                    {formatTruncate(
                                                      sixCardBook.back
                                                    )}
                                                  </span>
                                                  /
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    {formatTruncate(
                                                      sixCardBook.lay
                                                    )}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="card 6"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "card 6",
                                          "card 6",
                                          singleCard,
                                          "m",
                                          1
                                        )
                                      }
                                    >
                                      <div id="rnr21" class="sus_cls">
                                        <span
                                          class="price-odd odd"
                                          id="runnercardspancard6"
                                        >
                                          {singleCard}
                                        </span>
                                        <span class="price-amount" id="rate21">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      sevenCardWinner
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  7
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="book1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      sevenCardBook.back > 0
                                                        ? ""
                                                        : "none"
                                                  }}
                                                >
                                                  <span
                                                    style={{ color: "green" }}
                                                  >
                                                    {formatTruncate(
                                                      sevenCardBook.back
                                                    )}
                                                  </span>
                                                  /
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    {formatTruncate(
                                                      sevenCardBook.lay
                                                    )}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="card 7"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "card 7",
                                          "card 7",
                                          singleCard,
                                          "m",
                                          1
                                        )
                                      }
                                    >
                                      <div id="rnr22" class="sus_cls">
                                        <span
                                          class="price-odd odd"
                                          id="runnercardspancard7"
                                        >
                                          {singleCard}
                                        </span>
                                        <span class="price-amount" id="rate22">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      eightCardWinner
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  8
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="book1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      eightCardBook.back > 0
                                                        ? ""
                                                        : "none"
                                                  }}
                                                >
                                                  <span
                                                    style={{ color: "green" }}
                                                  >
                                                    {formatTruncate(
                                                      eightCardBook.back
                                                    )}
                                                  </span>
                                                  /
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    {formatTruncate(
                                                      eightCardBook.lay
                                                    )}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="card 8"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "card 8",
                                          "card 8",
                                          singleCard,
                                          "m",
                                          1
                                        )
                                      }
                                    >
                                      <div id="rnr23" class="sus_cls">
                                        <span
                                          class="price-odd odd"
                                          id="runnercardspancard8"
                                        >
                                          {singleCard}
                                        </span>
                                        <span class="price-amount" id="rate23">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      nineCardWinner
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  9
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="book1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      nineCardBook.back > 0
                                                        ? ""
                                                        : "none"
                                                  }}
                                                >
                                                  <span
                                                    style={{ color: "green" }}
                                                  >
                                                    {formatTruncate(
                                                      nineCardBook.back
                                                    )}
                                                  </span>
                                                  /
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    {formatTruncate(
                                                      nineCardBook.lay
                                                    )}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="card 9"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "card 9",
                                          "card 9",
                                          singleCard,
                                          "m",
                                          1
                                        )
                                      }
                                    >
                                      <div id="rnr24" class="sus_cls">
                                        <span
                                          class="price-odd odd"
                                          id="runnercardspancard9"
                                        >
                                          {singleCard}
                                        </span>
                                        <span class="price-amount" id="rate24">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      tenCardWinner
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  10
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="book1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      tenCardBook.back > 0
                                                        ? ""
                                                        : "none"
                                                  }}
                                                >
                                                  <span
                                                    style={{ color: "green" }}
                                                  >
                                                    {formatTruncate(
                                                      tenCardBook.back
                                                    )}
                                                  </span>
                                                  /
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    {formatTruncate(
                                                      tenCardBook.lay
                                                    )}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="card 10"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "card 10",
                                          "card 10",
                                          singleCard,
                                          "m",
                                          1
                                        )
                                      }
                                    >
                                      <div id="rnr25" class="sus_cls">
                                        <span
                                          class="price-odd odd"
                                          id="runnercardspancard10"
                                        >
                                          {singleCard}
                                        </span>
                                        <span class="price-amount" id="rate25">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      elevenCardWinner
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  J
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="book1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      elevenCardBook.back > 0
                                                        ? ""
                                                        : "none"
                                                  }}
                                                >
                                                  <span
                                                    style={{ color: "green" }}
                                                  >
                                                    {formatTruncate(
                                                      elevenCardBook.back
                                                    )}
                                                  </span>
                                                  /
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    {formatTruncate(
                                                      elevenCardBook.lay
                                                    )}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="card 11"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "card 11",
                                          "card 11",
                                          singleCard,
                                          "m",
                                          1
                                        )
                                      }
                                    >
                                      <div id="rnr26" class="sus_cls">
                                        <span
                                          class="price-odd odd"
                                          id="runnercardspancard11"
                                        >
                                          {singleCard}
                                        </span>
                                        <span class="price-amount" id="rate26">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      twelveCardWinner
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Q
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="book1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      twelveCardBook.back > 0
                                                        ? ""
                                                        : "none"
                                                  }}
                                                >
                                                  <span
                                                    style={{ color: "green" }}
                                                  >
                                                    {formatTruncate(
                                                      twelveCardBook.back
                                                    )}
                                                  </span>
                                                  /
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    {formatTruncate(
                                                      twelveCardBook.lay
                                                    )}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="card 12"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "card 12",
                                          "card 12",
                                          singleCard,
                                          "m",
                                          1
                                        )
                                      }
                                    >
                                      <div id="rnr27" class="sus_cls">
                                        <span
                                          class="price-odd odd"
                                          id="runnercardspancard12"
                                        >
                                          {singleCard}
                                        </span>
                                        <span class="price-amount" id="rate27">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      thirteenCardWinner
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  K
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="book1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      thirteenCardBook.back > 0
                                                        ? ""
                                                        : "none"
                                                  }}
                                                >
                                                  <span
                                                    style={{ color: "green" }}
                                                  >
                                                    {formatTruncate(
                                                      thirteenCardBook.back
                                                    )}
                                                  </span>
                                                  /
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    {formatTruncate(
                                                      thirteenCardBook.lay
                                                    )}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="card 13"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "card 13",
                                          "card 13",
                                          singleCard,
                                          "m",
                                          1
                                        )
                                      }
                                    >
                                      <div id="rnr28" class="sus_cls">
                                        <span
                                          class="price-odd odd"
                                          id="runnercardspancard13"
                                        >
                                          {singleCard}
                                        </span>
                                        <span class="price-amount" id="rate28">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          display: activeTabIndex == 2 ? "" : "none",
                          color: "white"
                        }}
                      >
                        <Lucky7SecondResult resultData={resultData} />
                      </div>
                    </div>

                    <div className="col-md-4 mobile-margin">
                      {showBetSlipPopup && (
                        <TPPopUpBetSlip
                          closeBetSlipParent={closeBetSlipMobile}
                          betObj={placeBetObject}
                          placeBetParent={placeBet}
                          betButtonShow={betButtonShow}
                          betErrorMessageObj={betErrorMessageObj}
                          betButtonShowLoaderShow={betButtonShowLoaderShow}
                          profileData={profileData}
                        />
                      )}
                      <TeenPattisCasinoBetslipWeb
                        showBetSlip={showBetSlip}
                        placeBetObject={placeBetObject}
                        closeBetSlipParent={closeBetSlip}
                        placeBetParent={placeBet}
                        betErrorMessageObj={betErrorMessageObj}
                        profileData={profileData}
                      ></TeenPattisCasinoBetslipWeb>
                      <div>
                        <div className="bets">
                          <strong>
                            Matched Bets (0)
                            <img
                              src={reconnecting}
                              alt="dc"
                              className="rounded disconnected"
                              style={{ display: "none" }}
                            />{" "}
                          </strong>
                          <div className="betting-table">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>Runner</th>
                                  <th>Price</th>
                                  <th>Size</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                {placedBets.map((bet, index) => {
                                  console.log("MATCHED BET:", bet);

                                  return (
                                    <tr
                                      key={index}
                                      style={{
                                        background:
                                          bet.type == "b"
                                            ? "#e9f6fc"
                                            : "#fce3e4"
                                      }}
                                    >
                                      <td>
                                        {displayRunnerName(bet.rnr)} - (
                                        {bet.cat_mid})
                                      </td>

                                      <td>{bet.amnt}</td>
                                      <td>{bet.rate}</td>
                                      <td></td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ClientLayoutWithOutHeader>
      <style>
        {`
          .lucky7second-scope .cards-layout.blackjack {
            position: relative;
            background: #000000;
            min-height: 210px;
          }

          .lucky7second-scope .cards-layout.blackjack::before {
            content: "";
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background: radial-gradient(
              ellipse 100% 44% at 50% calc(30% + 45px),
              rgba(62, 193, 65, 0.95) 0%,
              rgba(62, 193, 65, 0.8) 15%,
              rgba(30, 80, 35, 0.5) 40%,
              #1e1e1e 55%,
              #1e1e1e 100%
            );
            opacity: 0.4;
            pointer-events: none;
            z-index: 0;
          }

          .lucky7second-scope .cards-layout.blackjack > * {
            position: relative;
            z-index: 1;
          }

          .lucky7second-scope .cards-layout.blackjack > .timerDiv2,
          .lucky7second-scope .cards-layout.blackjack > .row.mt-2 {
            position: relative;
            z-index: 10;
          }

          .lucky7second-scope .timerDiv2 {
            padding-top: 0 !important;
          }

          .lucky7second-scope .timerDiv2 .col-md-2 {
            position: relative !important;
            top: -14px !important;
            right: -12px !important;
          }

          .lucky7second-scope .teenpatti-base-timer {
            position: relative;
            width: 50px;
          }

          .lucky7second-scope .cards-layout.blackjack .sound-icon {
            right: 18px !important;
            transform: scale(0.9);
            transform-origin: center;
          }

            .player-scope .tp-card {
              top: 25px;
              align-items: center;
              justify-content:center; 
            }
            .player-scope .tp-card img{
              height: 75px;
            }
          .cards-tp-card {
            margin-top: 0px;
          }
            .player-scope .table-player {
          gap: 9px !important;
           align-items: center;
           display: flex;
          flex-direction: column;
          justify-content: flex-start;
          height: auto !important;
          min-height: auto !important;
                }
          .player-scope .table-player .player-dt {
            display: flex !important;
            flex-direction: column;
            align-items: center !important;
            max-width: none;
            width: auto;
            color: #d7bc7b !important;
            font-size: 12px;
            font-weight: 700;
          }
          .tb-content{
            padding-top:3px;
          }

          .lucky7second-scope .lucky7second-player-card {
            border-color: rgba(173, 172, 172, 0.4) !important;
          }

/* ---------------- DESKTOP ---------------- */

        @media (min-width:992px){
          .table-player .player-name{
            font-size:13px;
          }
          .market-titlebar .market-name-badge span,
          .market-titlebar .market-overarround strong,
          .market-titlebar .market-overarround-lay strong{
            font-size:14px;
          }
          .player-scope .tp-hand {
            position: relative;
            width: 180px !important;
            height: 100px !important;
            margin: 10px -10px;
            overflow: visible;
            border-radius: 12px;
            border: 1px solid rgba(178, 220, 175, 0.25);
          }
          .aviator-scope .row{
            margin-left:0 !important;
            margin-right:0 !important;
          }
          .col-md-8{
            padding-left:19px !important;
            margin-bottom:9px;
          }
          .left-content{
            padding-right:6px;
          }
          .aviator-scope .col-12{
            padding-left:0 !important;
            padding-right:0 !important;
          }
          .left-content .market-titlebar {
            width: 100%;
            display: flex;
            height: 20px;
          }
          .runner-runner .lobby-btn {
            height: 38px !important;
            min-height: 38px !important;
            padding: 2px 4px !important;
          }
          .lucky7second-scope .cards-layout.blackjack {
            min-height: 210px;
          }
          .lucky7second-scope .lucky7second-player-card {
            width: 188px !important;
            height: 93px !important;
          }
          .volume-wrapper {
            margin-top: -35px;
          }
        }

/* ---------------- MOBILE---------------- */
        @media (max-width:991px){
          .table-player{
            font-size:16px !important;
          }
          .market-titlebar strong{
            font-size:13px;
          }
          .col-md-8{
            padding-left:15px !important;
          }
          .left-content{
            padding-right:0;
          }

          .lucky7second-scope .player-scope .tp-card {
            width: 51px;
            height: 66px;
          }

          .lucky7second-scope .player-scope .tp-card img {
            height: 60px;
          }

          .lucky7second-scope .player-scope .tp-hand-single {
            width: 176px;
            height: 128px;
          }

          .lucky7second-scope .lucky7second-player-card {
            width: 120px !important;
            height: 70px !important;
          }

          .lucky7second-scope .player-scope .tp-card.flip img {
            animation: none !important;
            transform: none !important;
          }
        }
        @media (max-width:576px){
          .margin-mob{
            margin-right: 5px !important;
            margin-left: 5px !important;
          }
          .lucky7second-scope .cards-layout.blackjack {
            min-height: 150px !important;
          }
          .lucky7second-scope .timerDiv2 .col-md-2 {
            top: -6px !important;
          }
          .lucky7second-scope .tp-card img{
            height: 40px !important;
            margin-left: 13px;
            border-radius: 5px;
          }
          .lucky7second-scope .player-scope .cards-tp-card img{
            height: 40px;   
            width: auto;
            border-radius: 6px;
          }
          .lucky7second-scope .player-scope .tp-card {
            width: 41px;
            height: 53px;
          }
          .lucky7second-scope .player-scope .tp-hand-single {
            width: 140px;
            height: 102px;
          }
          .mobile-margin{
            margin-top: 8px;
         }
          .lucky7second-scope .player-scope .tp-hand {
            position: relative;
            width: 120px !important; 
            height: 48px !important;  
            margin: 4px 4px;    
            overflow: visible;
            border-radius: 12px;
            border: 1px solid rgba(178, 220, 175, 0.25);     
          }
          .footer-divbpg{
            display:flex;
            align-items:center;
            justify-content:space-between;
            flex-wrap:nowrap; 
            border-radius:8px;
          }
          .aviator-scope .col-12{
            padding-left:0 !important;
            padding-right:0 !important;
          }
          .titlebarname p{
            font-size:18px !important;
          }
          .player-scope .table-player {
            justify-content: center; 
            gap: 1px !important;  
            padding: 0 10px !important;         
          }
          .lucky7second-scope .lucky7second-player-card {
              width: 120px !important;
              height: 70px !important;
          }
          .btn-group-sm .btn{
            padding:2px 6px;
            font-size:12px;
          }
          .btn-group{
            flex-wrap:nowrap !important;
          }
          .footer-divbpg .btn-group-sm .btn{
            padding:6px 4px !important;
            font-size:12px !important;
            line-height:1.2;
            margin-top: 0;
          }
          .footer-divbpg .titlebarname{
            flex:1;         
            max-width:none !important;
            padding-left:4px;
          }
          .titlebarname p{
            font-size:17px !important;
            margin:0;
            margin-bottom: 12px;
            margin-left: 18px;
          }
          .tp20-player{
            width:48% !important;  
          }
          .tp20-hand{
            width:100% !important;
          }
          @scope (.aviator-scope) {
            .video-button {
              padding: 0px;
              background-color: #4f4f4f;
              color: #fff;
              font-family: Montserrat-ExtraBold;
              font-size: 12px !important;
              font-style: normal;
              font-weight: 500;
              height: 35px !important;
              margin-right: 3px;
              text-align: center;
              width: 1px !important;
              max-width: auto;
            }
          }
        }
          @media (max-width: 768px) {
            
            .timerDiv2 {
              margin-bottom: 0 !important;
            }
            .footer-divbpg {
              margin-top: 0 !important;
            }
            .volume-wrapper {  
              height: 10px !important;
              margin-top: -7px !important;
              line-height: 16px;
              margin-bottom: 10px;
            }
          }
        
        .tp-hand {
          display: flex;
          justify-content: center; 
          align-items: center; 
        }
    
      `}
      </style>
    </div>
  );
}
